import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import { getW } from 'Lib/w/w';
import 'Vendor/owlcarousel/owl.carousel.min';

const $body = $('body');
const $slider = $('.list-author-blocks__slider');
const cSliderOn = 'owl-carousel';

function setSlider(e, width) {
    if (width < eksmoBP.smMin) {
        $slider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    smartSpeed: speed * 2,
                    autoWidth: true,
                });
        });
    } else {
        $slider.trigger('destroy.owl.carousel');
    }
}

setSlider(false, getW());
$body.on('eksmoResizeWidth', setSlider);